/**
 * Recharge Customer Login (/tools/recurring/login) -- copy tweaks
 *
 * Recharge server-renders this page's markup (plain light-DOM HTML, no
 * shadow root, unlike the PDP subscription widget in
 * recharge-widget-custom.js). Colors/fonts/border-radius/branding are
 * handled in assets/custom-style.css via Recharge's own CSS custom
 * property theming API (--rc-title-font etc.) -- this file only does the
 * text changes CSS can't: dropping "(sends SMS and email)" since this
 * page only offers an email code, and adding the subtitle/helper/support
 * copy the reference layout has that Recharge's own markup doesn't.
 *
 * Guarded to no-op immediately if .rc-login isn't on the page, so this
 * loading globally (alongside recharge-widget-custom.js) costs nothing
 * elsewhere.
 */
(function () {
  var SUPPORT_EMAIL = 'help@fabtab.com';

  function enhance() {
    var loginSection = document.querySelector('.rc-login');
    if (!loginSection) return;

    // Subtitle under "Login", mirroring the reference layout's
    // brand-name + "Member portal" byline -- our own site header already
    // shows the Fab Tab logo above this section, so this just adds the
    // second line rather than repeating the brand name too.
    var heading = loginSection.querySelector('.rc-login--header-title');
    if (heading && !loginSection.querySelector('.rc-login-subtitle')) {
      var subtitle = document.createElement('p');
      subtitle.className = 'rc-login-subtitle';
      subtitle.textContent = 'Manage your Fab Tab subscription';
      heading.insertAdjacentElement('afterend', subtitle);
    }

    // Placeholder, matching the reference copy exactly. The "Email"
    // label itself is hidden via CSS (.rc-login-form-label) as redundant
    // with this placeholder, rather than relabeled here.
    var emailInput = loginSection.querySelector('.rc-login-form-email');
    if (emailInput && emailInput.placeholder === 'Email') {
      emailInput.placeholder = 'you@example.com';
    }

    // Drop "(sends SMS and email)" -- this page only offers an email code.
    var buttonText = loginSection.querySelector('[data-rc-login-form-submit-btn-animation] span');
    if (buttonText && /sms/i.test(buttonText.textContent)) {
      buttonText.textContent = 'Email me a login code';
    }

    // Helper text under the button, and a support line at the bottom of
    // the card -- both present in the reference layout, absent from
    // Recharge's own markup. Helper text lives inside the same step-1
    // wrapper as the form, so it hides/shows in sync with that step
    // automatically once Recharge's own JS toggles it.
    var form = loginSection.querySelector('.rc-login-form');
    if (form && !loginSection.querySelector('.rc-login-helper-text')) {
      var helper = document.createElement('p');
      helper.className = 'rc-login-helper-text';
      helper.textContent = "Use the email you order with and we'll send you a one-time code. No password needed.";
      form.insertAdjacentElement('afterend', helper);
    }

    var body = loginSection.querySelector('.rc-login--body');
    if (body && !loginSection.querySelector('.rc-login-support')) {
      var support = document.createElement('p');
      support.className = 'rc-login-support';
      support.innerHTML = 'Questions? Email <a href="mailto:' + SUPPORT_EMAIL + '">' + SUPPORT_EMAIL + '</a>';
      body.appendChild(support);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  // Recharge may re-render step content client-side after the initial
  // load; every branch above already guards against re-adding duplicate
  // elements, so re-running this on any DOM change is safe.
  var loginRoot = document.querySelector('.rc-login');
  if (loginRoot) {
    new MutationObserver(enhance).observe(loginRoot, { childList: true, subtree: true });
  }
})();
